import { i18n } from '../../../i18n/i18n'

import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../../store'
import { replaceElementPosition } from '../../../views/LabelBuilder/LabelBuilder.slice'
import InputText from '../../InputText'

interface Props {
    elementId: string
    x: number
    y: number
}

type CombinedProps = Props & ConnectedProps<typeof connector>

class PositionProperty extends Component<CombinedProps> {
    handleInputChange = (name: string, value: string) => {
        const { elementId } = this.props
        const numValue = Number(value)
        if (isNaN(numValue)) return

        if (name === 'x') this.props.replaceElementPosition(elementId, numValue, this.props.y)
        if (name === 'y') this.props.replaceElementPosition(elementId, this.props.x, numValue)
    }

    render () {
        const { x, y } = this.props
        return (
            <div className="grid grid-cols-2 gap-4 mb-2">
                <InputText
                    type="number"
                    name="x"
                    value={String(Math.round(x))}
                    label={'X position (px)'}
                    onChange={this.handleInputChange}
                />
                <InputText
                    type="number"
                    name="y"
                    value={String(Math.round(y))}
                    label={'Y position (px)'}
                    onChange={this.handleInputChange}
                />
            </div>
        )
    }
}

function mapStateToProps (state: RootState) {
    return {}
}

const mapDispatchToProps = {
    replaceElementPosition,
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(PositionProperty)